export const NB_THREADS = 32
